
import { mapGetters } from "vuex";
import {sendAli} from "~/utils/send-ali";

export default {
  name: 'TattooDisplay',
  props: {
    language: null,
    lan: null,
    svgCode: null,
    aLiId: null,
    imgSrc: {
      type: Array,
      default: () => []
    },
    load: Boolean,
    code: {
      type: Number,
      default: 200
    },
    error_message: String,
    template: null,
    target_content: null,
    isMobile: Boolean,
    isRemaker: null,
    mesFb: null,
    config: null,
    percentage: {
      type: Number,
      default: 0
    },
    lastUploadTime: null,
    lastUpload: null,
    drawLoading: Boolean,
    generateParam: null,
  },
  data() {
    return {
      selectedImage: null,
      previewShow: false,
      previewSrc: "",
      // 默认展示的示例图片
      defaultImages: [
        'https://remaker.ai/userspace/saasbox/image/ai-tattoo/tattoo_remaker.png',
        'https://remaker.ai/userspace/saasbox/image/ai-tattoo/tattoo_remaker1.png'
      ]
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    hasImages() {
      return this.imgSrc && this.imgSrc.length > 0 && this.code === 200 && !this.load;
    },
    displayImages() {
      return this.hasImages ? this.imgSrc : this.defaultImages;
    },
    displayImage() {
      if (this.hasImages) {
        return this.selectedImage || this.imgSrc[0];
      } else {
        return this.selectedImage || this.defaultImages[0];
      }
    }
  },
  watch: {
    imgSrc: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.selectedImage = newVal[0];
        } else {
          // 当没有真实图片时，选择第一个默认图片
          this.selectedImage = this.defaultImages[0];
        }
      },
    },
    drawLoading(newVal) {
      if (!newVal) {
        this.notifyContentLoaded();
      }
    }
  },
  mounted() {
    // 初始化时选择第一个默认图片
    if (!this.hasImages) {
      this.selectedImage = this.defaultImages[0];
    }
  },
  methods: {
    selectImage(url) {
      this.selectedImage = url;
      // 如果是默认图片，不触发真实的交互
      if (!this.hasImages) return;
    },
    previewImage(url) {
      // 如果是默认图片，不允许预览
      if (!this.hasImages) return;
      this.previewSrc = url;
      this.previewShow = true;
      // 保持与原组件相同的事件名
      this.$emit('showEmit', url);
    },
    download() {
      if (!this.hasImages || !this.selectedImage) return;
      this.$emit('down', this.selectedImage);
    },
    share() {
      if (!this.hasImages || !this.selectedImage) return;
      sendAli(this.aLiId, "share", this.selectedImage);
      this.$emit('share', this.selectedImage);
    },
    tryOnTattoo() {
      if (!this.hasImages || !this.selectedImage) return;
      // 跳转到try-tattoo页面并传递当前选中图片
      this.$router.push({
        path: `/${this.$i18n.locale === 'en' ? '' : `${this.$i18n.locale}/`}tattoo-simulator/`,
        query: { tattoo: encodeURIComponent(this.selectedImage) }
      });
    },
    notifyContentLoaded() {
      this.$root.$emit('content-loaded');
    },
  },
};
